"use strict";

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;

export default function () {
    require('startbootstrap-sb-admin/js/sb-admin');
    require('bootstrap-material-design/dist/js/bootstrap-material-design');

    jQuery(document).ready(function ($) {
        // @see https://fezvrasta.github.io/bootstrap-material-design/assets/js/src/application.js
        $('body').bootstrapMaterialDesign();
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/material.js